import ComponentWithSocket from '../../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from './../../../store';

import template from './forgot.vue';

interface UserCheck {
    auctionUserStatus: number;
}

@Component({
    mixins: [template]
})

export default class LoginUser extends ComponentWithSocket {

    private email: string;

    private data: {
        errorText: string
        successMessage: boolean
    } = {
        errorText: '',
        successMessage: false
    };

    constructor() {

        super();

        // Assign session values to store for global dispatch
        this.wsListener.onPost('auth.password.forgot', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (!success) {
                this.data.errorText = data;
                return;
            }

            this.data.errorText = '';
            this.data.successMessage = true;

        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {

    }

    doPasswordForgot() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.password.forgot', {
            email: this.email
        });

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/password/forgot/index.ts